import React from 'react';
export function TermsConditions() {
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-537">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-538">
        <div className="mb-12" data-id="element-539">
          <a href="/" className="inline-flex items-center space-x-1 mb-8 group" data-id="element-540">
            <span className="text-2xl font-display font-bold text-white" data-id="element-541">
              Tru
            </span>
            <span className="text-2xl font-display font-bold text-teal-500" data-id="element-542">
              ID
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500 group-hover:scale-125 transition-transform" data-id="element-543"></span>
          </a>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-544">
            Términos y Condiciones
          </h1>
          <div className="h-1 w-20 bg-teal-500 rounded" data-id="element-545"></div>
        </div>

        <div className="prose prose-invert max-w-none space-y-10 text-gray-300 leading-relaxed" data-id="element-546">
          <p data-id="element-547">
            El presente documento establece los términos y condiciones
            aplicables al uso de la plataforma TruID.
          </p>

          <section data-id="element-548">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-549">
              1. ACCESO A LA CUENTA
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-550">
              <li data-id="element-551">
                Cada cuenta o usuario creado es uso personal e intransferible.
              </li>
              <li data-id="element-552">
                Podrá acceder a ella cualquier persona natural mayor de edad que
                complete el formulario de registro correspondiente.
              </li>
              <li data-id="element-553">
                El uso de la Cuenta implica la aceptación plena de estos
                términos y condiciones.
              </li>
            </ul>
          </section>

          <section data-id="element-554">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-555">
              2. RESPONSABILIDAD DE LA PLATAFORMA
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-556">
              <li data-id="element-557">
                TruID administra información para la validación segura de
                identidades digitales, y permite que múltiples plataformas
                externas se conecten con el fin de poder realizar validaciones
                de identidad u otros servicios, de acuerdo a la aprobación
                explícita de cada usuario. Sin embargo, TruID no tiene ni asume
                ninguna responsabilidad sobre los productos, servicios o
                problema de cualquier tipo relacionados con dichas plataformas.
              </li>
              <li data-id="element-558">
                En caso de cualquier inconveniente o reclamo relacionado con
                plataformas que usan a TruID como método de validación e
                identificación de usuarios o para cualquier otra función, deberá
                realizar su reclamo respectivo a dicha plataforma, no teniendo
                TruID ninguna responsabilidad sobre funciones, productos o
                servicios sobre plataformas interconectadas con TruID.
              </li>
            </ul>
          </section>

          <section data-id="element-559">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-560">
              3. VIGENCIA Y MODIFICACIONES
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-561">
              <li data-id="element-562">
                La vigencia de la cuenta es de uso indefinido, salvo que el
                usuario renuncie expresamente a su uso.
              </li>
              <li data-id="element-563">
                TruID se reserva el derecho de modificar, suspender o cancelar
                las cuentas de usuarios, informando oportunamente a los usuarios
                a través de sus canales oficiales.
              </li>
            </ul>
          </section>

          <section data-id="element-564">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-565">
              4. PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-566">
              <li data-id="element-567">
                Al afiliarse, el usuario autoriza el tratamiento de sus datos
                personales conforme a la legislación vigente, exclusivamente
                para fines informativos y promocionales relacionados con el
                programa.
              </li>
              <li data-id="element-568">
                Los datos no serán compartidos con terceros sin consentimiento
                del titular, salvo requerimiento legal. Puede ver más detalles
                en el documento de nuestras Políticas de Privacidad y Protección
                de Datos Personales.
              </li>
            </ul>
          </section>

          <section data-id="element-569">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-570">
              5. USO INDEBIDO Y CANCELACIÓN
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-571">
              <li data-id="element-572">
                El uso fraudulento, indebido o contrario a estos términos puede
                dar lugar a la anulación inmediata de la cuenta y la pérdida de
                sus beneficios.
              </li>
              <li data-id="element-573">
                La organización podrá suspender o eliminar una cuenta en caso de
                mal uso sin necesidad de notificación previa.
              </li>
            </ul>
          </section>

          <section data-id="element-574">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-575">
              6. VIGENCIA
            </h2>
            <p data-id="element-576">
              La vigencia de estos Términos y Condiciones de Uso es desde el 12
              de septiembre de 2025 y permanecerá vigente hasta que exista una
              nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}